import Vue from 'vue'
import App from './App.vue'
import element from './plugins/element'
import router from './router'
console.log(router)
Vue.config.productionTip = false
Vue.use(element)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
